React = require 'react'
t = require('views/internal/recup-with-helpers')('canonical_comment')
Util = require 'lib/util'
moment = require 'moment'
CanonicalCommentInlineReply = require 'views/canonical-comment/canonical-comment-inline-reply'

{ Avatar } = require '@atlassian/trello-canonical-components/canonical-card'

{
  CommentActions
  CommentContainer
  CommentInfo
  CommentText
  Header
  IconButton
} = require '@atlassian/trello-canonical-components/canonical-comment'

replyIcon = require 'images/canonical-comment/send-icon.svg'
dismissIcon = require 'images/canonical-comment/dismiss-icon.svg'

module.exports = class CanonicalComment extends React.Component
  displayName: 'CanonicalComment'

  render: t.renderable ->
    {
      board
      comment
      commentMemberCreator
      memberCreator
      date
      isEdited
      canReply
      isReplying
      hasReplied
      onReplyClick
      onSaveClick
      onCancelClick
      replyAction
      replyMessage
      onChangeReplyMessage
    } = @props

    avatarHash = commentMemberCreator?.get('avatarHash')

    t.div =>
      t.div '.canonical-comment', =>
        t.tag CommentContainer, =>
          t.tag Header, =>
            t.tag Avatar, {
              key: commentMemberCreator.id
              deactivated: board.getOrganization()?.getMemberType(commentMemberCreator) == 'deactivated'
              img: avatarHash and [window.avatarDomain, avatarHash, '30.png'].join('/')
              img2x: avatarHash and [window.avatarDomain, avatarHash, '50.png'].join('/')
              initials: commentMemberCreator?.get('initials')
              lightBackground: true
            }
            t.tag CommentInfo, {
              name: commentMemberCreator?.get('fullName')
              date: if isEdited then "#{moment(date).fromNow()} #{t.l('edited')}" else moment(date).fromNow()
            }
          if comment?.textHtml
            t.tag CommentText, { className: 'markeddown' }, =>
              t.raw comment.textHtml
          t.tag CommentActions, =>
            if canReply
              t.tag IconButton, {
                icon: replyIcon
                onClick: onReplyClick
                className: 'canonical-comment-icon-button'
              }, =>
                t.format 'reply'
      if isReplying || hasReplied
        t.tag CanonicalCommentInlineReply, {
          memberCreator
          onSaveClick
          onCancelClick
          isReplying
          hasReplied
          replyAction
          replyMessage
          onChangeReplyMessage
        }



// WEBPACK FOOTER //
// ./app/scripts/views/canonical-comment/canonical-comment-components.coffee